import { configureIguazuRPC, setProcedures } from 'iguazu-rpc';

import procedures from './procedures';
import { MODULE_ID } from '../../../constants';

const configureProcedures = () => {
  configureIguazuRPC({
    getToState: (state) => state.getIn(['modules', MODULE_ID, 'procedures']),
  });
  setProcedures(procedures);
};

export { configureProcedures };
